import type React from "react";
import BackgroundIllustration from "../assets/svgs/submit-documents/background.svg";
import { PostStatus } from "../types/models/post.models.types";

type AppProps = {
  title?: string;
  message: string;
  status?: string;
};
const RejectionCard: React.FunctionComponent<AppProps> = ({
  title,
  message,
  status,
}) => {
  if (status === PostStatus.flaggedReview) {
    return (
      <div className="relative pt-10 pr-28 pb-10 pl-8 border border-border rounded-10 w-full overflow-hidden">
        <div className="top-0 left-0 absolute bg-rejectionmessagebg w-1 h-full" />
        <div className="flex justify-between items-center h-full">
          <div className="flex flex-col gap-3">
            <p className="text-rejectionmessagetext text-xs">
              Reason for flagging
            </p>

            <p className="font-semibold text-base leading-6">{message}</p>
          </div>
        </div>
        <div className="right-0 bottom-0 absolute h-fit text-rejectionmessagetext">
          <BackgroundIllustration />
        </div>
      </div>
    );
  }
  if (status === "postDeleted") {
    return (
      <div className="relative py-5 pr-16 pl-12 border border-border rounded-10 rounded-b-none w-full overflow-hidden">
        <div className="top-0 left-0 absolute bg-rejectionmessagebg w-1 h-full" />
        <div className="flex justify-between items-center h-full">
          <div className="flex flex-col">
            <p className="font-semibold text-sm leading-8">{title}</p>
            <p className="font-semibold text-secondary text-xs leading-4">
              {message}
            </p>
          </div>
        </div>
        <div className="right-0 bottom-0 absolute h-fit text-rejectionmessagetext">
          <BackgroundIllustration />
        </div>
      </div>
    );
  }
  if (status === "error") {
    return (
      <div className="relative py-5 pr-16 pl-12 border border-border rounded-10 rounded-b-none w-full overflow-hidden">
        <div className="top-0 left-0 absolute bg-rejectionmessagebg w-1 h-full" />
        <div className="flex justify-between items-center h-full">
          <div className="flex flex-col">
            <p className="font-semibold text-sm leading-8">{title}</p>
            <p className="font-semibold text-secondary text-xs leading-4">
              {message}
            </p>
          </div>
        </div>
        <div className="right-0 bottom-0 absolute h-fit text-rejectionmessagetext">
          <BackgroundIllustration />
        </div>
      </div>
    );
  }
  if (status === "pending") {
    return (
      <div className="relative py-5 pr-16 pl-12 border border-border rounded-10 rounded-b-none w-full overflow-hidden">
        <div className="top-0 left-0 absolute bg-primarybuttonbg w-1 h-full" />
        <div className="flex justify-between items-center h-full">
          <div className="flex flex-col">
            <p className="font-semibold text-sm leading-8">{title}</p>
            <p className="font-semibold text-secondary text-xs leading-4">
              {message}
            </p>
          </div>
        </div>
        <div className="right-0 bottom-0 absolute h-fit text-primarybuttonbg">
          <BackgroundIllustration />
        </div>
      </div>
    );
  }

  if (status === "pass") {
   return (<div className="relative py-5 pr-16 pl-12 border border-border rounded-10 rounded-b-none w-full overflow-hidden">
      <div className="top-0 left-0 absolute bg-rejectionmessagebg w-1 h-full" />
      <div className="flex justify-between items-center h-full">
        <div className="flex flex-col">
          <p className="font-semibold text-sm leading-8">{title}</p>
          <p className="font-semibold text-secondary text-xs leading-4">
            {message}
          </p>
        </div>
      </div>
      <div className="right-0 bottom-0 absolute h-fit text-rejectionmessagetext">
        <BackgroundIllustration />
      </div>
    </div>)
  }

  return (
    <div className="relative pt-10 pr-28 pb-10 pl-20 border border-border rounded-10 w-full overflow-hidden">
      <div className="top-0 left-0 absolute bg-rejectionmessagebg w-1 h-full" />
      <div className="flex justify-between items-center h-full">
        <div className="flex flex-col">
          <p className="font-semibold text-xl">{message}</p>
        </div>
      </div>
      <div className="right-0 bottom-0 absolute h-fit text-rejectionmessagetext">
        <BackgroundIllustration />
      </div>
    </div>
  );
};

export default RejectionCard;
